import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Sales
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanGetRequest = simpleAction(TYPES.SALESMAN_GET_REQUEST);

/**
 * Request sales success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanGetSuccess = simpleAction(TYPES.SALESMAN_GET_SUCCESS);

/**
 * Request sales error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanGetError = simpleAction(TYPES.SALESMAN_GET_FAIL);

/**
 * Request Sale
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanLoadRequest = simpleAction(TYPES.SALESMAN_LOAD_REQUEST);

/**
 * Request Sale success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanLoadSuccess = simpleAction(TYPES.SALESMAN_LOAD_SUCCESS);

/**
 * Request Sale error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanLoadError = simpleAction(TYPES.SALESMAN_LOAD_FAIL);

/**
 * Create Sale
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanCreateRequest = simpleAction(TYPES.SALESMAN_CREATE_REQUEST);

/**
 * Create Sale Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanCreateSuccess = simpleAction(TYPES.SALESMAN_CREATE_SUCCESS);

/**
 * Create Sale Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanCreateError = simpleAction(TYPES.SALESMAN_CREATE_FAIL);

/**
 * Update Sale
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanUpdateRequest = simpleAction(TYPES.SALESMAN_UPDATE_REQUEST);

/**
 * Update Sale Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanUpdateSuccess = simpleAction(TYPES.SALESMAN_UPDATE_SUCCESS);

/**
 * Update Sale Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const salesmanUpdateError = simpleAction(TYPES.SALESMAN_UPDATE_FAIL);
